import requestProvider from "./axiosHandler";

const getAllRecipes = () => {

    return requestProvider
        .get('/recipe/get-all')
}

const createRecipe  = (list) => {

    return requestProvider
        .post('/recipe', {
            billOfMaterials: list.billOfMaterials,
            recipe: list.recipe,
            recipeProductionCosts: list.recipeProductionCosts
        })
}

const updateRecipe = (list) => {
    return requestProvider
        .put('/recipe', list)
}

const deleteRecipe = (id) => {

    return requestProvider
        .delete(`/recipe/delete/${id}`)
}

const getRecipeById = (id) => {
    return requestProvider
        .get(`/recipe/getAllById/${id}`)
}

const getRecipeWithStockId = (id) => {
    return requestProvider
        .get(`/recipe/get-by-stock-id/${id}`)
}

const cloneRecipe = (list) => {
    return requestProvider
        .post(`/recipe/clone`, list)
}

const recipeStockList = (id) => {
    return requestProvider
        .get(`/recipe/get-by-stocks/${id}`)
}

const filterRecipes = (list) => {
    return requestProvider
        .post('recipe/filter', list)
}

const getRecipeCodes = () => {
    return requestProvider
        .get('recipe/get-codes')
};

const getRecipesWithPage = (list) => {
    return requestProvider
        .post('/recipe/page-filter', list)
};

export {
    filterRecipes,
    recipeStockList,
    getAllRecipes,
    createRecipe,
    updateRecipe,
    deleteRecipe,
    getRecipeById,
    getRecipeWithStockId,
    cloneRecipe,
    getRecipeCodes,
    getRecipesWithPage
}